import { useContext } from 'react'
import { AccountSearchContext } from '../containers/contexts/search'

export const useAccountSearch = () => {
  const { accountSearchState, searchAccounts } = useContext(AccountSearchContext)
  return { accountSearchState, searchAccounts }
}
